import SearchPageApp from './SearchPageApp';

export default SearchPageApp;
